import { render } from "./wWarning.vue?vue&type=template&id=1f772723&ts=true"
import script from "./wWarning.vue?vue&type=script&lang=ts"
export * from "./wWarning.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__